<template>
  <BarChart
    :request-status="requestStatus"
    :categories="categories"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BarChart from '@/components/cards/models/BarChart';
import { ENTITIES, SAC_STATUS_FIELDS, OPERATION } from '@/services/charts-service';
import EventBus from '@/utils/event-bus';
import { mapActions } from 'vuex';
import proprietaryModel from '@/mixins/proprietary-model';
import highchartsBasics from '@/mixins/highcharts-basics';
import colors from '@/utils/colors';
import { msToTime } from '@/utils/date';

export default {
  name: 'SacAverageTimeForTreatmentsByOperator',
  components: {
    BarChart,
  },
  mixins: [
    proprietaryModel,
    highchartsBasics,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawData: {},
      cardOptions: {
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        yAxis: {
          stackLabels: {
            formatter() {
              return msToTime(this.total);
            },
          },
        },
        tooltip: {
          pointFormatter() {
            const { y, color, series } = this;
            const value = msToTime(y);
            return `<span style="color:${color}">●</span> ${series.name}: <b>${value}</b><br/>`;
          },
        },
      },
    };
  },
  computed: {
    data() {
      if (this.rawData?.points) {
        return this.isExpandedCard ? this.rawData.points : this.rawData.points.slice(0, this.maxItemsToBeDisplayed);
      }

      return [];
    },
    categories() {
      return this.data?.map(({ x: operator }) => operator);
    },
    series() {
      if (!this.data) {
        return [];
      }

      return [
        {
          name: this.$t('mixins.cardsModel.averageTime'),
          color: colors.defaultSerieColor,
          data: this.data.map(({ z: calls }) => calls ? calls : null),
        },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getAggregatedData',
        entity: ENTITIES.SAC_STATUS,
        points_parser: 'points',
        params: {
          fields: [SAC_STATUS_FIELDS.statusChangeTime],
          label: 'averageTimeByOperator',
          operators: OPERATION.AVG,
          grouping: [
            SAC_STATUS_FIELDS.userName,
            SAC_STATUS_FIELDS.userId,
          ],
          sorting: 'desc',
          sortFields: ['averageTimeByOperator'],
        },
      })
        .then((response) => {
          this.rawData = response;

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error(err);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
